import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-950">
              Kategorie <span className="text-primary-500">Produktów</span>
            </h2>
            <p className="text-foreground-500 text-sm mt-2 max-w-lg">
              Przeglądaj zweryfikowane produkty według kategorii – każda prowadzi do dedykowanej sekcji w arkuszu Kakobuy Spreadsheet
            </p>
          </div>
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
            14 Kategorii
          </span>
        </div>

        <div className="category-scroll flex gap-5 overflow-x-auto pb-4 -mx-4 px-4 md:px-0 snap-x snap-mandatory">
          {categories.map((cat, index) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[240px] md:w-[260px] snap-start group cursor-pointer"
            >
              <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1">
                <div className="relative w-full h-[200px] overflow-hidden">
                  <img
                    src={cat.imageUrl}
                    alt={`${cat.name} – Kakobuy Spreadsheet`}
                    title={`${cat.name} – Kakobuy Spreadsheet`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900">{cat.name}</h3>
                  <p className="text-xs text-foreground-400 mt-1">{cat.nameEn}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}